import React, { useState } from "react";
import { Row, Col, Button } from "reactstrap";
import { ADMIN_PAYMENT_METHOD } from "common/components/admin-payment-form-proptypes";
import CampaignGroupPropType from "../campaign-group-prop-type";
import PurchaseFlowModals from "./purchase-flow-modals";
import ImpressionBoostDropdown from "./impression-boost-dropdown";

const propTypes = {
  campaignGroup: CampaignGroupPropType.isRequired,
  adminPaymentMethod: ADMIN_PAYMENT_METHOD
};

const ImpressionBoostPurchaseFlow = ({ campaignGroup, adminPaymentMethod = null }) => {
  const boostOptions = campaignGroup.eligible_impression_boosts || [];
  const [selectedBoost, setSelectedBoost] = useState(boostOptions[0]);
  const [displayPurchaseModal, setDisplayPurchaseModal] = useState(false);

  if (
    !boostOptions.length ||
    !campaignGroup.impression_boost_purchase_link ||
    !campaignGroup.eligible_to_purchase_impression_boost
  ) {
    return null;
  }

  const filteredAdminPaymentMethod = adminPaymentMethod
    ? {
        ...adminPaymentMethod,
        fundingSourceOptions: adminPaymentMethod.fundingSourceOptions?.filter(option =>
          ["internal", "stripe_invoice"].includes(option.value)
        )
      }
    : null;

  const purchaseModalData = {
    showPaymentFailNote: false,
    showUpgradeSell: false,
    showOrderSummary: true,
    confirmationButtonText: "Purchase",
    impressionBoost: selectedBoost,
    formTarget: campaignGroup.impression_boost_purchase_link,
    hideCouponLine: true,
    hideExistingCards: true
  };

  return (
    <>
      <div>
        <h6 className="text-uppercase font-weight-semibold font-size-small mb-3">
          Purchase Extra Views
        </h6>
        <Row className="align-items-start">
          <Col xs="7" className="pr-1 pl-0">
            <ImpressionBoostDropdown
              options={boostOptions}
              selectedBoost={selectedBoost}
              onSelect={setSelectedBoost}
            />
          </Col>
          <Col xs="5" className="pl-0">
            <Button
              color="primary"
              size="md"
              className="btn-sharp w-100 d-flex align-items-center justify-content-center"
              onClick={() => setDisplayPurchaseModal(true)}
            >
              <i className="fa fa-cart-shopping mr-2" />
              <span className="text-truncate">Purchase Boost</span>
            </Button>
          </Col>
        </Row>
      </div>

      <PurchaseFlowModals
        campaignGroup={campaignGroup}
        purchaseModalData={purchaseModalData}
        displayPurchaseModal={displayPurchaseModal}
        setDisplayPurchaseModal={setDisplayPurchaseModal}
        adminPaymentMethod={filteredAdminPaymentMethod}
        purchaseSource="campaign_results"
        purchaseType="extra_views"
        supportsStripeRetail
      />
    </>
  );
};

ImpressionBoostPurchaseFlow.propTypes = propTypes;

export default ImpressionBoostPurchaseFlow;
